;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { useRouter } from 'next/router'
import {
  getPositiveNumberQueryParameter,
  getQueries,
} from 'src/deprecated/utils/queryParams'
import { z } from 'zod'

const pageParameter = 'page'
const brandParameter = 'brand'
const sortParameter = 'sort'
const stocklistParameter = 'stocklist'
const originParameter = 'origin'

const sortBySchema = z.enum([
  'originalPrice',
  'inventory',
  '-originalPrice',
  '-inventory',
])
const getSortParameter = (params: URLSearchParams) => {
  return sortBySchema.safeParse(params.get(sortParameter)).data
}
type InventorySortByType = typeof sortBySchema._output

export const useInventoryQueryParams = () => {
  const router = useRouter()

  const params = new URLSearchParams(getQueries(router.asPath))

  const page = getPositiveNumberQueryParameter(params, pageParameter, 1)

  const setPage = (pageNumber: number) => {
    params.set(pageParameter, pageNumber.toString())
    router.replace({ search: params.toString() }, undefined, {
      shallow: true,
    })
  }

  const toggleBrandsFilter = (brand: string) => {
    // if brand is in the current remove it
    const currentBrands = params.getAll(brandParameter)
    params.delete(brandParameter)

    // add other brands first because we want to keep the new brand at the end
    const newBrands = currentBrands.filter((b) => b !== brand)
    newBrands?.forEach((brandsFromList) =>
      brandsFromList ? params.append(brandParameter, brandsFromList) : null,
    )

    // toggle the brand - adds the brand only if the brand is not in the list
    if (!currentBrands.includes(brand) && brand) {
      params.append(brandParameter, brand)
    }

    // remove brands url if not in the list
    if (params.getAll(brandParameter).length === 0) {
      params.delete(brandParameter)
    }

    // Reset the page to 1 when the filter is changed
    params.set(pageParameter, '1')
    router.replace({ search: params.toString() }, undefined, {
      shallow: true,
    })
  }

  const clearBrandsFilter = () => {
    params.delete(brandParameter)
    params.set(pageParameter, '1')
    router.replace({ search: params.toString() }, undefined, {
      shallow: true,
    })
  }

  const currentSort = getSortParameter(params)

  const setSort = (sort: InventorySortByType) => {
    if (sort === currentSort) {
      return
    }
    params.set(sortParameter, sort)
    params.set(pageParameter, '1')
    router.replace({ search: params.toString() }, undefined, {
      shallow: true,
    })
  }

  const stocklistQid = params.get(stocklistParameter) ?? undefined

  const setStocklistQid = (qid: string) => {
    if (qid === stocklistQid) {
      return
    }
    params.set(stocklistParameter, qid)
    params.set(pageParameter, '1')
    router.replace({ search: params.toString() }, undefined, {
      shallow: true,
    })
  }

  const origin = params.get(originParameter) ?? undefined

  return {
    page,
    setPage,
    toggleBrandsFilter,
    clearBrandsFilter,
    setSort,
    sort: currentSort,
    brandsFilter: params.getAll(brandParameter),
    stocklistQid,
    setStocklistQid,
    origin,
  }
}
